import { FETCH_PROPERTIES, FETCH_PROPERTIES_SUCCESS, FETCH_PROPERTIES_FAIL } from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  data: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_PROPERTIES:
      return { ...state, loading: true }
    case FETCH_PROPERTIES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false
      }
    case FETCH_PROPERTIES_FAIL:
      return { ...state, loading: false }
    default:
      return (state)
  }
}
